//Imports
import React, { useCallback, useEffect } from "react";

//Controls
import { Button, Modal } from "@gpstrackit/gtc-react-controls";

//Components
import { NotificationManager, NotificationContainer } from "Components/Notifications";

//Hooks
import { useIntl } from "react-intl";

//Actions
import { manageDeleteManageKeyFob, reset } from "./redux/slice";
import { useDispatch, useSelector } from "react-redux";


const DeleteManageKeyFob = ({ refresh }) => {
  //Redux
  const dispatch = useDispatch();
  const { open, loading, result, error, deleteKeyFob, deleteKeyFobList } =
  useSelector((state) => state.manageDeleteManageKeyFobRedux);
  
  //Language 
  const { messages } = useIntl();

  //Handlers and utils
  const handleClose = useCallback(() => dispatch(reset()), []);

  const handleDeleteSubmit = useCallback(() => {
    if (deleteKeyFob) {
      dispatch(manageDeleteManageKeyFob({ id: deleteKeyFob?.id }));
      return;
    }
    if (deleteKeyFobList?.length) {
      dispatch(manageDeleteManageKeyFob({ items: deleteKeyFobList }));
    }
  }, [deleteKeyFob, deleteKeyFobList]);

  //Effects
  useEffect(() => {
    if (!error) return;
    NotificationManager.error(
      error?.error || messages["errorMessage"],
      messages["error"],
      3000,
      null,
      null,
      "error"
    );
    dispatch(reset({ error: null }));
  }, [error]);

  useEffect(() => {
    if (!result) return;
    const messageSuccess = deleteKeyFob
      ? messages["manage_deletedKeyFob"]
      : messages["manage_deletedKeyFobs"];
    NotificationManager.success(
      messageSuccess,
      messages["success"],
      3000,
      null,
      null,
      "success"
    );
    refresh();
    dispatch(reset());
  }, [result]);
  
  return (
    <Modal
      title={
        deleteKeyFob
          ? messages["manage_deleteManageKeyFob_deleteKeyFob"]
          : messages["manage_deleteManageKeyFob_deleteKeyFobs"]
      }
      size="small"
      open={open}
      handleClose={handleClose}
      loading={loading}
      footer={
        <div>
          <Button
            variant="secondary"
            style={{ marginRight: "5px" }}
            onClick={() => handleClose()}
            isDisabled={loading}
          >
            {messages["cancel"]}
          </Button>
          <Button
            variant="warning"
            onClick={() => handleDeleteSubmit()}
            isDisabled={loading}
          >
            {messages["delete"]}
          </Button>
        </div>
      }
    >
      <div style={{ padding: "10px 25px" }}>
        <p>{messages["manage_deleteManageKeyFob_confirmationMessage"]}</p>
        <ul>
          {deleteKeyFob ? (
            <li>{deleteKeyFob?.hex}</li>
          ) : (
            deleteKeyFobList.map((keyFob) => <li>{keyFob.hex}</li>)
          )}
        </ul>
      </div>
      <NotificationContainer />
    </Modal>
  );
};

export default DeleteManageKeyFob;
